module.exports = __webpack_public_path__ + "static/loui-6731e9efe2bed21a4a4a1c23b609e709.jpg";